export const pluginId = '@builder.io/plugin-algolia';
